import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import Users from './Users';
import columnTypes from '../../components/cms/grid/columnTypes';
import gc from '../../components/cms/gridComponents';
import ModelService from '../../services/user.service';
import CompanyService from '../../services/company.service';
import PreviewImage from '../../components/previewImage';

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>)
  },
  {
    name: 'image',
    title: '',
    value: ({ item }) => (
      <div className="center va-m">
        <Link to={ModelService.getUpdateUrl(item.id)}>
          <PreviewImage className="img-avatar" width="35" src={ModelService.getAvatar(item.image, 35, 35, true)} alt={item.username} />
        </Link>
      </div>
    ),
    filter: false,
    sort: false,
    tdClassName: 'p-0 va-m',
  },
  {
    name: 'company_id',
    title: t('Company'),
    value: ({ item }) => item.company ? ( <Link to={CompanyService.getUpdateUrl(item.company_id)}>{item.company.title} ({item.company.id})</Link>) : (<span/>)
  },
  {
    name: 'email',
    title: t('E-mail'),
  },
  {
    name: 'username',
    title: t('Username'),
  },
  {
    name: 'first_name',
    title: t('First name'),
  },
  {
    name: 'last_name',
    title: t('Last name'),
  },
  // {
  //   name: 'phone',
  //   title: t('Phone'),
  // },
  {
    name: 'created_at',
    title: t('Created at'),
    value: gc.dateDataCell({ attr: 'created_at' }),
    filter: false,
  },
  {
    name: 'last_activity_at',
    title: t('Last activity'),
    value: gc.dateDataCell({ attr: 'last_activity_at' }),
    filter: false,
  },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusOptions(t)),
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color={ModelService.getColorByType(type)}>
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypeOptions(t)),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
  }),
);

export default hoistStatics(enhance)(Users);



// WEBPACK FOOTER //
// ./src/views/users/index.js